// AXOIX AI Characters - Complete 22 Agent Crew
// Dedicated website portraits from the approved AXOIX character library
import hyperionImg from "../images/team/characters/website/hyperion.webp";
import forgeImg from "../images/team/characters/website/forge.webp";
import ledgerImg from "../images/team/characters/website/ledger.webp";
import keeperImg from "../images/team/characters/website/keeper.webp";
import probeImg from "../images/team/characters/website/probe.webp";
import haulImg from "../images/team/characters/website/haul.webp";
import cipherImg from "../images/team/characters/website/cipher.webp";
import recruitImg from "../images/team/characters/website/recruit.webp";
import guardianImg from "../images/team/characters/website/guardian.webp";
import linkImg from "../images/team/characters/website/link.webp";
import chorusImg from "../images/team/characters/website/chorus.webp";
import conciergeImg from "../images/team/characters/website/concierge.webp";
import sealImg from "../images/team/characters/website/seal.webp";
import remedyImg from "../images/team/characters/website/remedy.webp";
import nurtureImg from "../images/team/characters/website/nurture.webp";
import arbiterImg from "../images/team/characters/website/arbiter.webp";
import barterImg from "../images/team/characters/website/barter.webp";
import campusImg from "../images/team/characters/website/campus.webp";
import scoutImg from "../images/team/characters/website/scout.webp";
import pulseImg from "../images/team/characters/website/pulse.webp";
import dispatchImg from "../images/team/characters/website/dispatch.webp";
import voyageImg from "../images/team/characters/website/voyage.webp";

export interface TeamMember {
  id: string;
  tImg: string;
  name: string;
  slug: string;
  title: string;
  description: string;
  capabilities: string[];
  phase: number;
}

const Teams: TeamMember[] = [
  // ========== PHASE 1 - Core (Active) ==========
  {
    id: "1",
    tImg: hyperionImg,
    name: "HYPERION",
    slug: "hyperion",
    title: "Core AI / Commander",
    description: "The mastermind orchestrating all operations. HYPERION coordinates between all AI characters, manages your dashboard, processes voice commands in 81 languages, and ensures every system works in harmony. Your primary interface to the entire platform.",
    capabilities: [
      "Voice command processing (6,100+ commands × 81 languages)",
      "Multi-language support (81 languages)",
      "Dashboard orchestration",
      "AI character coordination",
      "Natural language understanding"
    ],
    phase: 1
  },
  {
    id: "2",
    tImg: forgeImg,
    name: "FORGE",
    slug: "forge",
    title: "Document AI / Processing",
    description: "Handles all document processing and project management. FORGE extracts data from documents, manages tasks, deadlines, team assignments, and milestones. Kanban boards, Gantt charts, and automated progress reports keep everything organized.",
    capabilities: [
      "Document processing & extraction",
      "Task & milestone tracking",
      "Kanban & Gantt charts",
      "Team assignment management",
      "Automated progress reports"
    ],
    phase: 1
  },
  {
    id: "3",
    tImg: ledgerImg,
    name: "LEDGER",
    slug: "ledger",
    title: "Finance & Accounting",
    description: "Your financial controller AI. LEDGER handles invoicing, expense tracking, double-entry accounting, tax calculations, and financial reporting. From petty cash to P&L statements, your finances are in expert hands.",
    capabilities: [
      "Double-entry accounting",
      "Invoice generation & tracking",
      "Expense management",
      "Tax calculation (GST, TDS)",
      "Financial reporting (P&L, Balance Sheet)"
    ],
    phase: 1
  },
  {
    id: "4",
    tImg: keeperImg,
    name: "KEEPER",
    slug: "keeper",
    title: "Inventory Management",
    description: "Controls your stock and inventory. KEEPER tracks stock levels, manages items, coordinates with suppliers, handles warehouse management, and ensures you never run out of critical items with low-stock alerts.",
    capabilities: [
      "Real-time inventory tracking",
      "Item & SKU management",
      "Low-stock alerts",
      "Multi-warehouse support",
      "Stock valuation"
    ],
    phase: 1
  },
  {
    id: "5",
    tImg: probeImg,
    name: "PROBE",
    slug: "probe",
    title: "Analytics & Insights",
    description: "Your data scientist AI. PROBE crunches numbers, generates reports, identifies trends, and provides actionable insights. From sales forecasts to performance metrics, PROBE turns raw data into business intelligence.",
    capabilities: [
      "Real-time analytics dashboards",
      "Sales & revenue forecasting",
      "Performance metrics tracking",
      "Custom report generation",
      "Trend identification & alerts"
    ],
    phase: 1
  },

  // ========== PHASE 2 - Enterprise ==========
  {
    id: "6",
    tImg: haulImg,
    name: "HAUL",
    slug: "haul",
    title: "Logistics & Shipping",
    description: "Manages your supply chain and logistics. HAUL tracks shipments, manages purchase orders, coordinates with suppliers, handles fleet management, and optimizes delivery routes.",
    capabilities: [
      "Shipment tracking",
      "Purchase order management",
      "Supplier coordination",
      "Fleet management",
      "Route optimization"
    ],
    phase: 2
  },
  {
    id: "7",
    tImg: cipherImg,
    name: "CIPHER",
    slug: "cipher",
    title: "Security & Compliance",
    description: "Keeps you secure and compliant. CIPHER monitors security threats, tracks document expirations, manages audit trails, and ensures your business meets all regulatory obligations.",
    capabilities: [
      "Security monitoring",
      "Compliance tracking",
      "Document expiry alerts",
      "Audit trail management",
      "Regulatory alerts"
    ],
    phase: 2
  },
  {
    id: "8",
    tImg: recruitImg,
    name: "RECRUIT",
    slug: "recruit",
    title: "HR / Hiring",
    description: "Manages your people and recruitment. RECRUIT handles employee records, attendance tracking, leave management, payroll preparation, recruitment pipelines, and performance reviews.",
    capabilities: [
      "Employee records management",
      "Attendance & leave tracking",
      "Payroll preparation",
      "Recruitment pipeline",
      "Performance reviews"
    ],
    phase: 2
  },
  {
    id: "9",
    tImg: guardianImg,
    name: "GUARDIAN",
    slug: "guardian",
    title: "Asset Management",
    description: "Tracks and manages all company assets. GUARDIAN monitors equipment, vehicles, software licenses, and property. Depreciation tracking, maintenance schedules, and asset lifecycle management.",
    capabilities: [
      "Asset tracking & tagging",
      "Depreciation calculations",
      "Maintenance scheduling",
      "License management",
      "Asset lifecycle tracking"
    ],
    phase: 2
  },

  // ========== PHASE 3 - Communications ==========
  {
    id: "10",
    tImg: linkImg,
    name: "LINK",
    slug: "link",
    title: "VoIP / PBX",
    description: "Powers your entire phone system. LINK manages extensions, routes calls, handles IVR, records conversations, and provides call analytics. FREE internal calling with all paid plans!",
    capabilities: [
      "FREE internal PBX & WebRTC calling",
      "Internal extensions: 3 / 10 / 15 / unlimited by plan",
      "Professional IVR builder",
      "Call recording & storage",
      "Click-to-call from CRM"
    ],
    phase: 3
  },
  {
    id: "11",
    tImg: chorusImg,
    name: "CHORUS",
    slug: "chorus",
    title: "Social Media Management",
    description: "Manages your social media presence. CHORUS schedules posts, monitors engagement, tracks mentions, analyzes performance, and helps maintain consistent brand voice across platforms.",
    capabilities: [
      "Multi-platform posting",
      "Content scheduling",
      "Engagement tracking",
      "Mention monitoring",
      "Performance analytics"
    ],
    phase: 3
  },
  {
    id: "12",
    tImg: conciergeImg,
    name: "CONCIERGE",
    slug: "concierge",
    title: "Customer Support Chat",
    description: "Your 24/7 customer support AI. CONCIERGE handles live chat, answers common questions, routes complex queries, and ensures customers always get timely assistance.",
    capabilities: [
      "24/7 live chat support",
      "FAQ automation",
      "Query routing",
      "Chat transcripts",
      "Customer satisfaction tracking"
    ],
    phase: 3
  },

  // ========== PHASE 4 - Business Services ==========
  {
    id: "13",
    tImg: sealImg,
    name: "SEAL",
    slug: "seal",
    title: "Digital Signing",
    description: "Secure Electronic Agreement & Ledger. SEAL handles all digital signatures — quotes, proposals, contracts, NDAs. FREE for ALL users! Legally compliant under IT Act 2000.",
    capabilities: [
      "E-signatures on quotes & contracts",
      "Multi-party signing workflow",
      "Document tracking & status",
      "Legal compliance (IT Act 2000)",
      "Complete audit trails"
    ],
    phase: 4
  },
  {
    id: "14",
    tImg: remedyImg,
    name: "REMEDY",
    slug: "remedy",
    title: "Complaint Management",
    description: "Resolution & Mediation for Your Disputes. REMEDY manages customer complaints with SLA monitoring, escalation workflows, and resolution tracking. FREE for ALL users!",
    capabilities: [
      "Complaint ticket system",
      "SLA monitoring & alerts",
      "Escalation workflows",
      "Resolution tracking",
      "Satisfaction surveys"
    ],
    phase: 4
  },
  {
    id: "15",
    tImg: nurtureImg,
    name: "NURTURE",
    slug: "nurture",
    title: "CRM / Customer Success",
    description: "Your customer relationship AI. NURTURE manages leads, tracks customer journeys, suggests follow-ups, monitors health scores, and helps retain and grow customer relationships.",
    capabilities: [
      "Lead management & scoring",
      "Customer journey tracking",
      "Follow-up automation",
      "Health score monitoring",
      "Retention strategies"
    ],
    phase: 4
  },
  {
    id: "16",
    tImg: arbiterImg,
    name: "ARBITER",
    slug: "arbiter",
    title: "Contract Management",
    description: "Manages all your contracts and agreements. ARBITER tracks terms, renewal dates, obligations, and ensures you never miss a deadline or compliance requirement.",
    capabilities: [
      "Contract repository",
      "Term & obligation tracking",
      "Renewal alerts",
      "Compliance monitoring",
      "Version control"
    ],
    phase: 4
  },

  // ========== PHASE 5 - Advanced ==========
  {
    id: "17",
    tImg: barterImg,
    name: "BARTER",
    slug: "barter",
    title: "Procurement",
    description: "Your procurement specialist AI. BARTER manages vendor relationships, compares quotes, tracks purchase requisitions, and optimizes your buying decisions.",
    capabilities: [
      "Vendor management",
      "Quote comparison",
      "Purchase requisitions",
      "Spend analytics",
      "Supplier performance"
    ],
    phase: 5
  },
  {
    id: "18",
    tImg: campusImg,
    name: "CAMPUS",
    slug: "campus",
    title: "Learning / Training",
    description: "Manages employee learning and development. CAMPUS tracks training programs, certifications, skill gaps, and creates personalized learning paths for your team.",
    capabilities: [
      "Training management",
      "Certification tracking",
      "Skill gap analysis",
      "Learning paths",
      "Progress tracking"
    ],
    phase: 5
  },
  {
    id: "19",
    tImg: scoutImg,
    name: "SCOUT",
    slug: "scout",
    title: "Market Research",
    description: "Your market intelligence AI. SCOUT monitors competitors, tracks industry trends, gathers market data, and provides insights to help you stay ahead of the competition.",
    capabilities: [
      "Competitor monitoring",
      "Industry trend tracking",
      "Market data gathering",
      "Opportunity identification",
      "Strategic insights"
    ],
    phase: 5
  },
  {
    id: "20",
    tImg: pulseImg,
    name: "PULSE",
    slug: "pulse",
    title: "Employee Engagement",
    description: "Monitors and improves employee engagement. PULSE conducts surveys, tracks sentiment, identifies concerns, and helps create a positive workplace culture.",
    capabilities: [
      "Employee surveys",
      "Sentiment analysis",
      "Engagement scoring",
      "Feedback collection",
      "Culture insights"
    ],
    phase: 5
  },
  {
    id: "21",
    tImg: dispatchImg,
    name: "DISPATCH",
    slug: "dispatch",
    title: "Field Service",
    description: "Manages field operations and service teams. DISPATCH schedules technicians, optimizes routes, tracks job completion, and ensures efficient on-site service delivery.",
    capabilities: [
      "Technician scheduling",
      "Route optimization",
      "Job tracking",
      "Service reports",
      "Mobile workforce management"
    ],
    phase: 5
  },
  {
    id: "22",
    tImg: voyageImg,
    name: "VOYAGE",
    slug: "voyage",
    title: "Tourism & Travel",
    description: "Your travel industry specialist. VOYAGE handles bookings, itinerary planning, customer experience management, travel agent commissions, and package creation. From tour operators to travel agencies — VOYAGE makes tourism management effortless.",
    capabilities: [
      "Booking management",
      "Itinerary planning",
      "Agent commissions",
      "Package creation",
      "Customer experiences"
    ],
    phase: 5
  },
];

export default Teams;
